import GET from "./GET";
const inPreview = GET("platform") || false;
export default inPreview;
